"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es6.function.name");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "dashboard"
  }, [_c("el-container", [_c("div", {
    staticClass: "top_box"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("\n        Hi " + _vm._s(_vm.name) + "，"), _c("span", {
    staticStyle: {
      "font-size": "24px",
      "margin-left": "10px"
    }
  }, [_vm._v("欢迎回来 "), _c("i", {
    staticClass: "el-icon-message-solid",
    staticStyle: {
      color: "#e7b139",
      "font-size": "28px",
      "margin-right": "10px"
    }
  })])]), _vm._v(" "), _c("div", [_c("el-date-picker", {
    attrs: {
      type: "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: _vm.value1,
      callback: function callback($$v) {
        _vm.value1 = $$v;
      },
      expression: "value1"
    }
  }), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.getIndexData
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.resetData
    }
  }, [_vm._v("重置")])], 1)]), _vm._v(" "), _vm.data.length == 0 ? _c("el-skeleton") : _vm._e(), _vm._v(" "), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isAdmin || _vm.name == "wangdi",
      expression: "isAdmin || name == 'wangdi'"
    }],
    staticClass: "card"
  }, [_c("el-row", [_c("h2", {
    staticClass: "cardTitle",
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("🎯 志成租物平台收益概览看板")]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.SwitchPlatform
    }
  }, [_vm._v("切换平台")])], 1), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/11.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.pay_all_money, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("支付订单金额")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/11.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.rate_money, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("订单服务费收入")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/11.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.no_saas_rate_money, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("订单服务费收入(非)")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/22.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.pay_sum, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("划扣流水(总)")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/22.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.jd_pay_sum, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("划扣流水(京东)")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/33.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      click: function click($event) {
        return _vm.getMoneyReal(6);
      }
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(this.money_fan_tj, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("返点总金额")])]), _vm._v(" "), _c("div", {
    staticClass: "imgbang"
  })])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/33.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      click: function click($event) {
        return _vm.getMoneyReal(1);
      }
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(this.money_hkhk_tj, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("划扣回款总金额")])]), _vm._v(" "), _c("div", {
    staticClass: "imgbang"
  })])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/33.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      click: function click($event) {
        return _vm.getMoneyReal(4);
      }
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(this.money_yetx_tj, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("提现总金额")])]), _vm._v(" "), _c("div", {
    staticClass: "imgbang"
  })])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/11.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.rate_money_all / 100, 2)) + "\n              ")]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("订单服务费抽成（0.01）")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/11.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.contract_money, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("合同费收入")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/22.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.hkhy_money, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("逾期划扣回款金额")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/22.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.data.hkhy_num) + "期")]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("逾期划扣回款期数")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/33.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      click: function click($event) {
        return _vm.getMoneyReal(2);
      }
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(this.money_htshc_tj, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("商户承担合同费用")])]), _vm._v(" "), _c("div", {
    staticClass: "imgbang"
  })])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/33.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      click: function click($event) {
        return _vm.getMoneyReal(3);
      }
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(this.money_yczf_tj, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("预存支付宝总金额")])]), _vm._v(" "), _c("div", {
    staticClass: "imgbang"
  })])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/11.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.data.ensign_sum) + "笔")]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("签约订单数")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/11.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.hkh_money, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("划扣手续费收入")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/22.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.hkhd_money, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("按时划扣回款金额")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/22.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.data.hkhd_num) + "期")]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("按时划扣回款期数")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "subitme"
  }, [_c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticStyle: {
      width: "40px"
    },
    attrs: {
      src: require("../../assets/33.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      click: function click($event) {
        return _vm.getMoneyReal(5);
      }
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "22px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(this.formatNum(this.money_qita_tj, 2)))]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "gray"
    }
  }, [_vm._v("其他充值")])]), _vm._v(" "), _c("div", {
    staticClass: "imgbang"
  })])])], 1)], 1), _vm._v(" "), _c("div", {
    staticClass: "card"
  }, [_c("h2", {
    staticClass: "cardTitle",
    staticStyle: {
      "margin-left": "15px",
      "margin-bottom": "20px"
    }
  }, [_vm._v("📒 店铺订单收入数据概览")]), _vm._v(" "), _c("el-row", [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#aad4ff)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/2.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("订单总值")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.all_money, 2)) + "元")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#aad4ff)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/2.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("已支付订单")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(_vm.data.pay_num) + "笔")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#69daec)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/1.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("收到蚂蚁链划扣流水")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.pay_sum - _vm.data.jd_pay_sum, 2)) + "元")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#69daec)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/1.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("收到京东划扣流水")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.jd_pay_sum, 2)) + "元")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#69daec)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/1.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("蚂蚁链可提现金额(低于50元不可提现)")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.alipay_money, 2)) + "元")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#b9f19b)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/4.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("蚂蚁链未入账金额(同步间隔30min)")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.money_wrz_tj, 2)) + "元")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#69daec)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/1.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("京东可提现金额(低于50元不可提现)")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.alipay_jd_money, 2)) + "元")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#b9f19b)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/4.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("京东未入账金额(同步间隔35min)")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.money_wrz_jd_tj, 2)) + "元")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#b9f19b)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/4.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("到期应还订单数")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.dq_num) + "笔")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#b9f19b)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/4.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("回款订单数")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.wc_num) + "笔")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#b9f19b)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/4.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("回款率")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.formatNum(this.wc_lv, 2)) + "%")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#fdd122)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/5.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("违约订单数")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.vy_num) + "笔")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#fdd122)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/5.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("违约订单总金额")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.formatNum(this.vy_sum_money, 2)) + "元")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#fdd122)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/5.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("违约订单待归还金额")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.formatNum(this.vy_dh_money, 2)) + "元")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#fda020)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/3.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("逾期订单数")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.yq_num) + "笔")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#fda020)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/3.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("逾期率")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.formatNum(this.yq_lv, 2)) + "%")])])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "subitme",
    staticStyle: {
      background: "linear-gradient(90deg,#fff,#fda020)"
    }
  }, [_c("div", {
    staticClass: "desktop-view subitem_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/3.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info"
  }, [_c("div", {
    staticClass: "subitem_info_label"
  }, [_vm._v("申请解约订单数")]), _vm._v(" "), _c("div", {
    staticClass: "subitem_info_value"
  }, [_vm._v(_vm._s(this.us_num) + "笔")])])])])], 1), _vm._v(" "), _c("div", {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "20px"
    }
  }, [_vm._v("\n        详细数据")]), _vm._v(" "), _c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("div", {
    staticClass: "order-item"
  }, [_c("div", {
    staticClass: "order-title"
  }, [_vm._v("订单转化数据")]), _vm._v(" "), _c("div", {
    staticClass: "order-chart"
  }, [_vm._v("\n             正常订单： " + _vm._s(_vm.info_result.zc_num) + "\n              "), _c("funnelChart", {
    ref: "funnelChart",
    attrs: {
      option: _vm.funnelOptions
    }
  })], 1)])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("div", {
    staticClass: "order-item"
  }, [_c("div", {
    staticClass: "order-title"
  }, [_vm._v("其他订单数据")]), _vm._v(" "), _c("div", {
    staticClass: "order-chart"
  }, _vm._l(_vm.salesData, function (item, index) {
    return _c("el-progress-item", {
      key: index
    }, [_c("div", {
      staticStyle: {
        margin: "10px 0 5px"
      }
    }, [_vm._v(_vm._s(item.name) + "--" + _vm._s(item.value) + "个")]), _vm._v(" "), _c("el-progress", {
      attrs: {
        percentage: item.value / _vm.maxValue * 100,
        status: item.status,
        "stroke-width": 20
      }
    })], 1);
  }), 1)])])], 1), _vm._v(" "), _c("div", {
    staticClass: "order-item"
  }, [_c("el-row", {
    staticStyle: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-around"
    },
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "tousu-item"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("🗳️ 投诉订单")]), _vm._v(" "), _c("div", {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.data.ts_num) + "个")])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "tousu-item"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("❌ 代扣投诉")]), _vm._v(" "), _c("div", {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.data.dk_ts_num) + "个")])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "tousu-item",
    staticStyle: {
      "border-right": "0"
    }
  }, [_c("span", {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("投诉率")]), _vm._v(" "), _c("el-progress", {
    attrs: {
      type: "circle",
      percentage: _vm.data.dk_all_num
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;